<ng-container *ngIf="billing; else free">
  <button mat-icon-button (click)="onChange(!billing, $event)">
    <mat-icon class="color-gray">attach_money</mat-icon>
  </button>
</ng-container>

<ng-template #free>
  <button mat-icon-button (click)="onChange(!billing, $event)">
    <mat-icon class="color-gray">money_off</mat-icon>
  </button>
</ng-template>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-billing-button/course-billing-button.component.html